import { connect } from "react-redux";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";

import Ledgers from "./Ledgers";
import Journals from "./Journals";
import CostCenters from "./CostCenters";
import Integrations from "../../company-settings/integrations-tab/Integrations";
import { Actions as ACCOUNTINGACTIONS } from "../../../store/actions/accountingActions";
import { useEffect } from "react";

const tabs = [
	{
		link: "/organisation/accounting/journals",
		name: "Journals",
	},
	{
		link: "/organisation/accounting/cost-centers",
		name: "Cost Centers",
	},
	{
		link: "/organisation/accounting/ledgers",
		name: "Ledgers",
	},
	{
		link: "/organisation/accounting/integrations",
		name: "Integrations",
	},
];

const Accounting = ({ tabs, getData }) => {
	const location = useLocation();
	const currentTab = location.pathname;

	useEffect(() => {
		getData();
	}, []);

	return (
		<>
			<div className="content">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Accounting</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="content bg-white mb-32">
				<ul className="nav nav-tabs nav-tabs-alt nav-justified">
					{tabs.map((tab) => {
						return (
							<li className={currentTab === tab.link ? "active" : ""}>
								<Link to={tab.link}>{tab.name}</Link>
							</li>
						);
					})}
				</ul>
				<Routes>
					<Route
						path="/journals"
						element={<Journals />}
					/>
					<Route
						path="/cost-centers"
						element={<CostCenters />}
					/>
					<Route
						path="/ledgers"
						element={<Ledgers />}
					/>
					<Route
						path="/integrations"
						element={<Integrations section={"Accounting"} />}
					/>
					<Route
						path="*"
						element={
							<Navigate
								to="/organisation/accounting/journals"
								replace
							/>
						}
					/>
				</Routes>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		tabs,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getData: () => dispatch(ACCOUNTINGACTIONS.getData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Accounting);
